module.exports = __webpack_public_path__ + "img/group.d8342a54.png";